import { UserManager } from "oidc-client-ts";
import { getOidcSettings } from "./oidcConfig";

let _instance: UserManager | null = null;

export function getUserManager(): UserManager {
  if (!_instance) {
    _instance = new UserManager(getOidcSettings());
  }
  return _instance;
}
